import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardImg,
  CardText,
  CardTitle
} from "reactstrap";
import "./mentors.css";

export default class index extends Component {
  render() {
    return (
      <div className='pt-5'>
        <Container>
          <Row className="justify-content-center mentor-headline">
            <Col>
              <h1 className="mentor-headline center-h1">Mentors For Success</h1>

  <hr className="mentor-underline mb-5" />
            </Col>
          </Row>
          <Row className="mt-4 justify-content-center">
            <Col className="left-align" xs={{ size: 11 }} lg={{ size: 11, offset: 1 }}>
              <p>
                We believe that real world mentors play a critical role in
                everyone’s success. At Lighthouse, we are committed to the
                success of our students even after they leave us. So we offer a
                unique “Mentors for Success” program for all students who
                successfully complete the Immersive Program.
              </p>
            </Col>
          </Row>
          <Row className="mt-4 justify-content-center">
            <Col xs={{ size: 11 }} lg={{ size: 3 }}>
              <Card className="clear-card left-align">
                <CardImg
                  top
                  width="100%"
                  src="img/mentors1-v2.png"
                  alt="Card image cap"
                />

                <CardTitle>
                  {" "}
                  <h3 className="mt-4 ">Paired Mentoring</h3>{" "}
                  <hr className="card-line mt-1" />
                </CardTitle>
             

                <CardText>
                  {" "}
                    Each student is assigned a mentor after the first six weeks
                    into the program. Mentors offer students advice regarding
                    jobs, opportunities, and challenges students may face with
                    projects and their journey.{" "}
                </CardText>
              </Card>
            </Col>
            <Col xs={{ size: 11 }} lg={{ size: 3 }} className='pt-5 pt-lg-0'>
              <Card className="clear-card left-align">
                <CardImg
                  top
                  width="100%"
                  src="img/mentors2-v2.png"
                  alt="Card image cap"
                />
                <CardTitle>
                  {" "}
                  <h3 className="mt-4 ">Scheduled Meetups</h3>{" "}
                  <hr className="card-line mt-1" />
                </CardTitle>

                <CardText>
                  {" "}
                    You’ll be able to work with your mentor to schedule regular
                    calls and meetings so you have continuous guidance even
                    after you leave Lighthouse. We’ll also provide meetup events
                    and workshops that both you and your mentors can attend.
                  {" "}
                </CardText>
              </Card>
            </Col>
            <Col xs={{ size: 11 }} lg={{ size: 3 }} className='pt-5 pt-lg-0'>
              <Card className="clear-card left-align">
                <CardImg
                  top
                  width="100%"
                  src="img/mentors3-v2.png"
                  alt="Card image cap"
                />
                <CardTitle>
                  {" "}
                  <h3 className="mt-4 ">Post Course Support </h3>{" "}
                  <hr className="card-line mt-1" />
                </CardTitle>

                <CardText>
                  {" "}
                    On-going guidance will help create accountability and
                    encouragement so that you can continue to grow in your
                    career and learn even after you graduate. Even high-ranking
                    professionals have mentors who continue to help them grow
                    and move forward. We help you start that now.
                  {" "}
                </CardText>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
